import { render, staticRenderFns } from "./table.vue.html?vue&type=template&id=73fa0095"
import script from "./table.controller.ts?vue&type=script&lang=js&external"
export * from "./table.controller.ts?vue&type=script&lang=js&external"
import style0 from "./table.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports